import React from 'react';
import { useStyles } from './TakisVideoModal.styles';
import Modal from '@material-ui/core/Modal';
import YouTube from 'react-youtube';
import { TakisSvg } from '../components/TakisSvgs';

const TakisVideoModal = ({videoId ,modalState, modalFunction}) => {
    const classes = useStyles();

    const opts = {
        height: '390',
        width: '640',
        playerVars: {
            autoplay: 1,
            cc_load_policy: 1,
            color: null,
            controls: 1,
            disablekb: 0,
            enablejsapi: 0,
            end: null,
            fs: 1,
            h1: null,
            iv_load_policy: 1,
            list: null,
            listType: null,
            loop: 0,
            modestbranding: null,
            origin: null,
            playlist: null,
            playsinline: null,
            rel: 0,
            showinfo: 1,
            start: 0,
            wmode: 'transparent',
            theme: 'dark',
            mute: 0
        },
    };

    const getPadding = () => {
        const width = 16
        const height = 9
        const padding = height * 100 / width
        return padding + '%'
    }

    return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={modalState}
                onClose={modalFunction}
            >
                <div className={classes.modal_video_body}>
                    <div className={classes.modal_video_inner}>
                        <div className={classes.modal_video_movie_wrap} style={{paddingBottom: getPadding()}}>
                            <button className={classes.close_button} onClick={modalFunction}><TakisSvg icon="x" svg_class={classes.button_icon} viewbox="0 0 24 24"/></button>
                            <YouTube className={classes.video_frame} videoId={videoId} opts={opts}/>
                        </div>
                    </div>
                </div>
            </Modal>
  );
}


export default TakisVideoModal;
